import React from "react";
import { HashRouter as Router, Routes, Route, Navigate } from "react-router-dom";

// Existing Imports
import Navbar from "./components/pages/Navbar.jsx";
import Hero from "./components/pages/Hero.jsx";
import Services from "./components/pages/Services.jsx";
import About from "./components/pages/About.jsx";
import Footer from "./components/pages/Footer.jsx";
import Contact from "./components/pages/Contact.jsx";
import Blog from "./components/pages/Blog.jsx";
import CareerPartnership from "./components/pages/CareerPartnership.jsx";

// --- NEW IMPORT ---
import BlogPost from "./components/pages/BlogPost.jsx"; 

import AdminDashboard from "./components/pages/AdminDashboard.jsx";
import Login from "./components/pages/Login.jsx";

function PrivateRoute({ children }) {
  const token = localStorage.getItem("adminToken");
  return token ? children : <Navigate to="/login" />;
}

function PublicLayout() {
  return (
    <>
      <Navbar />
      <Hero />
      <Services />
      <Blog />
      <CareerPartnership />
      <About />
      <Contact />
      <Footer />
    </>
  );
}

function App() {
  return (
    <Router>
      <Routes>
        {/* Public Site (One Page Layout) */}
        <Route path="/" element={<PublicLayout />} />

        {/* --- NEW ROUTE: Single Blog Post --- */}
        {/* Matches /#/blog/my-post-slug */}
        <Route 
          path="/blog/:slug" 
          element={
            <>
              {/* <Navbar /> */}
              <BlogPost />
              {/* <Footer /> */}
            </>
          } 
        />

        {/* Admin Login */}
        <Route path="/login" element={<Login />} />

        {/* Protected Admin Dashboard */}
        <Route
          path="/dashboard"
          element={
            <PrivateRoute>
              <AdminDashboard />
            </PrivateRoute>
          }
        />

        {/* Catch-all redirect */}
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </Router>
  );
}

export default App;